let parser

export default {
  isObject (item) {
    return item && typeof item === 'object' && !Array.isArray(item);
  },

  isShallow (item) {
    return Array.isArray(item) && item.find((item) => typeof item === 'object') ? false : true;
  },

  assign (target, ...sources) {

    if (!sources.length) return target;
    const source = sources.shift();

    if (this.isObject(target) && this.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          this.assign(target[key], source[key]);
        } else {
          if (this.isShallow(source[key])) Object.assign(target, { [key]: source[key] });
          else {
            if (!target[key]) Object.assign(target, { [key]: [] });
            Object.assign(target, { [key]: source[key].map((item, index) => this.assign(target[key][index] || {}, item)) });
          }
        }
      }
    }

    return this.assign(target, ...sources);
  },

  dateToTimeString: function(date) {

    date = date || new Date();

    var timeString = date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    return timeString;
  },

  getQueryParam: function(key) {
      key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
      var match = location.search.match(new RegExp("[?&]"+key+"=([^&]+)(&|$)"));
      return match && decodeURIComponent(match[1].replace(/\+/g, " "));
  },

  throttle: function(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
      var context = scope || this;

      var now = +new Date,
          args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  },

  truncate: function(string,n,useWordBoundary) {
      var toLong = string.length>n,
      s_ = toLong ? string.substr(0,n-1) : string;
      s_ = useWordBoundary && toLong ? s_.substr(0,s_.lastIndexOf(' ')) : s_;
      return  toLong ? s_ + '&hellip;' : s_;
  },

  inArray: function(needle, haystack) {
      var length = haystack.length;
      for(var i = 0; i < length; i++) {
          if(haystack[i] == needle) return true;
      }
      return false;
  },

  stripDomain: function(url) {
          return url.replace("http://", '')
                    .replace("https://", '')
                    .split('/')[0];
  },

  topLevelDomain: function(url) {
    var domain = this.stripDomain(url);

    return domain.split('.').slice(-2).join('.').split(':')[0];
  },

  inIframe: function() {
      try {
          return window.self !== window.top;
      } catch (e) {
          return true;
      }
  },

  getJsonFromUrl: function(_url,mode) {

      var regex = /[?&]([^=#]+)=([^&#]*)/g,

      url = _url,
      params = {},
      match;

      while(match = regex.exec(url)) {
          params[match[1]] = match[2];
      }

      var _originUrl = _url.split("?");
      var _neddle = params['t'];

      return (mode) ? _neddle : {'url': _originUrl[0],'params': params};
  },

  getQueryString: function(obj) {
      var str = [];
        for(var p in obj)
          if (obj.hasOwnProperty(p) && obj[p] != null) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        return str.join("&");
  },

  svgParse: function(svgXml) {
    if (!parser) {
        parser = new DOMParser()
    }

    return parser.parseFromString(svgXml, 'image/svg+xml').documentElement
  },

  streamToHttps: function(streamUrl) {
      // console.log('streamToHttps',streamUrl, window.location.protocol)
      if (window.location.protocol == 'https:' && streamUrl.indexOf("https://") == -1) {
          streamUrl = streamUrl.replace("http://", "https://");
      }

      return streamUrl
  },

  getCookie: function(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
  },

    uuidv4: function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    getPropByString: function(obj, propString) {
        if (!propString)
            return obj;

        var prop, props = propString.split('.');

        for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
            prop = props[i];

            var candidate = obj[prop];
            if (candidate !== undefined) {
                obj = candidate;
            } else {
                break;
            }
        }
        return obj[props[i]];
    },

    // converts Date Strings like "2010-03-15 10:30:00" to Date Object, even in iOS
    parseDate: function(dateString) {

        dateString = String(dateString);
        const regex = /\d{4}[- :]\d{2}[- :]\d{2}[- :]\d{2}[- :]\d{2}[- :]\d{2}/gm;

        if(regex.test(dateString)) {
            var arr = dateString.split(/[- :]/);
            return new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
        }
        else {
            console.log('unknown dateString format', dateString);
            return null;
        }

    }
}



// WEBPACK FOOTER //
// ./src/plugins/thp-helpers/helpers.js